import MUIFab, { FabProps as MUIFabProps } from '@mui/material/Fab';

export type FabProps<C extends React.ElementType = React.ElementType> = MUIFabProps<C, { component?: C }>;

export const Fab = MUIFab;
